import { ListItemIcon as MuiListItemIcon } from '@mui/material';

export default MuiListItemIcon;
